
 
import { axiosRequest, AxiosRequestOptions } from "../api";
import  config from '../../config';


import {RefreshTokenInput, TokenOutput, UpdateProfileOutput, UploadProfilePhotoOutput, RemoveProfilePhotoInput, RemoveProfilePhotoOutput, PrepareChangePasswordInput, PrepareChangePasswordOutput, ChangePasswordInput, ChangePasswordOutput, LogoutInput, LogoutOutput, LoginOrRegisterInput, LoginOrRegisterOutput, VerifyRegistrationMobileInput, VerifyRegistrationMobileOutput, ResendOtpCodeInput, ResendOtpCodeOutput, CompleteRegistrationInput, LoginByPasswordInput, LoginByPasswordOutput, RequestLoginByOtpInput, RequestLoginByOtpOutput, LoginByOtpInput, RequestRecoveryInput, RequestRecoveryOutput, ConfirmRecoveryInput, ConfirmRecoveryOutput, FinalizeRecoveryInput, FinalizeRecoveryOutput, IdentityInput, IdentityOutput, RedirectInput, RedirectOutput, UpdateAccountMobileInput, UpdateAccountMobileOutput, VerifyUpdateAccountMobileInput, VerifyUpdateAccountMobileOutput, ProvincesQueryOutput, CitiesQueryOutput, ProfileOutput } from '../../types/account';

export default  {
 
    
    cachedClientVersions(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest  ("GET",`${config.apiUrl.account}/ManagerCore/CachedClientVersions${queryParams || ""}`,undefined, options);
    },
 
    
    invalidateClientVersionsCache(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest  ("POST",`${config.apiUrl.account}/ManagerCore/InvalidateClientVersionsCache`,data, options);
    },
 
    
    refresh(data : RefreshTokenInput, options?: AxiosRequestOptions) { 
        return axiosRequest< TokenOutput, RefreshTokenInput >("POST",`${config.apiUrl.account}/MembershipCommand/Refresh`,data, options);
    },
 
    
    updateProfile(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest< UpdateProfileOutput >("POST",`${config.apiUrl.account}/MembershipCommand/UpdateProfile`,data, options);
    },
 
    
    uploadProfilePhoto(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest< UploadProfilePhotoOutput >("POST",`${config.apiUrl.account}/MembershipCommand/UploadProfilePhoto`,data, options);
    },
 
    
    removeProfilePhoto(data : RemoveProfilePhotoInput, options?: AxiosRequestOptions) { 
        return axiosRequest< RemoveProfilePhotoOutput, RemoveProfilePhotoInput >("POST",`${config.apiUrl.account}/MembershipCommand/RemoveProfilePhoto`,data, options);
    },
 
    
    prepareChangePassword(data : PrepareChangePasswordInput, options?: AxiosRequestOptions) { 
        return axiosRequest< PrepareChangePasswordOutput, PrepareChangePasswordInput >("POST",`${config.apiUrl.account}/MembershipCommand/PrepareChangePassword`,data, options);
    },
 
    
    changePassword(data : ChangePasswordInput, options?: AxiosRequestOptions) { 
        return axiosRequest< ChangePasswordOutput, ChangePasswordInput >("POST",`${config.apiUrl.account}/MembershipCommand/ChangePassword`,data, options);
    },
 
    
    logout(data : LogoutInput, options?: AxiosRequestOptions) { 
        return axiosRequest< LogoutOutput, LogoutInput >("POST",`${config.apiUrl.account}/MembershipCommand/Logout`,data, options);
    },
 
    
    loginOrRegister(data : LoginOrRegisterInput, options?: AxiosRequestOptions) { 
        return axiosRequest< LoginOrRegisterOutput, LoginOrRegisterInput >("POST",`${config.apiUrl.account}/MembershipCommand/LoginOrRegister`,data, options);
    },
 
    
    verifyRegistrationMobile(data : VerifyRegistrationMobileInput, options?: AxiosRequestOptions) { 
        return axiosRequest< VerifyRegistrationMobileOutput, VerifyRegistrationMobileInput >("POST",`${config.apiUrl.account}/MembershipCommand/VerifyRegistrationMobile`,data, options);
    },
 
    
    resendOtpCode(data : ResendOtpCodeInput, options?: AxiosRequestOptions) { 
        return axiosRequest< ResendOtpCodeOutput, ResendOtpCodeInput >("POST",`${config.apiUrl.account}/MembershipCommand/ResendOtpCode`,data, options);
    },
 
    
    completeRegistration(data : CompleteRegistrationInput, options?: AxiosRequestOptions) { 
        return axiosRequest< TokenOutput, CompleteRegistrationInput >("POST",`${config.apiUrl.account}/MembershipCommand/CompleteRegistration`,data, options);
    },
 
    
    loginByPassword(data : LoginByPasswordInput, options?: AxiosRequestOptions) { 
        return axiosRequest< LoginByPasswordOutput, LoginByPasswordInput >("POST",`${config.apiUrl.account}/MembershipCommand/LoginByPassword`,data, options);
    },
 
    
    requestLoginByOtp(data : RequestLoginByOtpInput, options?: AxiosRequestOptions) { 
        return axiosRequest< RequestLoginByOtpOutput, RequestLoginByOtpInput >("POST",`${config.apiUrl.account}/MembershipCommand/RequestLoginByOtp`,data, options);
    },
 
    
    loginByOtp(data : LoginByOtpInput, options?: AxiosRequestOptions) { 
        return axiosRequest< TokenOutput, LoginByOtpInput >("POST",`${config.apiUrl.account}/MembershipCommand/LoginByOtp`,data, options);
    },
 
    
    requestRecovery(data : RequestRecoveryInput, options?: AxiosRequestOptions) { 
        return axiosRequest< RequestRecoveryOutput, RequestRecoveryInput >("POST",`${config.apiUrl.account}/MembershipCommand/RequestRecovery`,data, options);
    },
 
    
    confirmRecovery(data : ConfirmRecoveryInput, options?: AxiosRequestOptions) { 
        return axiosRequest< ConfirmRecoveryOutput, ConfirmRecoveryInput >("POST",`${config.apiUrl.account}/MembershipCommand/ConfirmRecovery`,data, options);
    },
 
    
    finalizeRecovery(data : FinalizeRecoveryInput, options?: AxiosRequestOptions) { 
        return axiosRequest< FinalizeRecoveryOutput, FinalizeRecoveryInput >("POST",`${config.apiUrl.account}/MembershipCommand/FinalizeRecovery`,data, options);
    },
 
    
    identity(data : IdentityInput, options?: AxiosRequestOptions) { 
        return axiosRequest< IdentityOutput, IdentityInput >("POST",`${config.apiUrl.account}/MembershipCommand/Identity`,data, options);
    },
 
    
    redirect(data : RedirectInput, options?: AxiosRequestOptions) { 
        return axiosRequest< RedirectOutput, RedirectInput >("POST",`${config.apiUrl.account}/MembershipCommand/Redirect`,data, options);
    },
 
    
    updateAccountMobile(data : UpdateAccountMobileInput, options?: AxiosRequestOptions) { 
        return axiosRequest< UpdateAccountMobileOutput, UpdateAccountMobileInput >("POST",`${config.apiUrl.account}/MembershipCommand/UpdateAccountMobile`,data, options);
    },
 
    
    verifyUpdateAccountMobile(data : VerifyUpdateAccountMobileInput, options?: AxiosRequestOptions) { 
        return axiosRequest< VerifyUpdateAccountMobileOutput, VerifyUpdateAccountMobileInput >("POST",`${config.apiUrl.account}/MembershipCommand/VerifyUpdateAccountMobile`,data, options);
    },
 
    
    provincesQuery(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ProvincesQueryOutput >("GET",`${config.apiUrl.account}/MembershipGeneralQuery/ProvincesQuery${queryParams || ""}`,undefined, options);
    },
 
    
    citiesQuery(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CitiesQueryOutput >("GET",`${config.apiUrl.account}/MembershipGeneralQuery/CitiesQuery${queryParams || ""}`,undefined, options);
    },
 
    
    profile(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ProfileOutput >("GET",`${config.apiUrl.account}/MembershipQuery/Profile${queryParams || ""}`,undefined, options);
    },
 
    
    setTokenAsCookie(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest  ("GET",`${config.apiUrl.account}/MembershipRedirectQuery/SetTokenAsCookie${queryParams || ""}`,undefined, options);
    },

};